export default __webpack_public_path__ + "static/media/clairefontaine3.8af62765.jpg";